module.exports = __webpack_public_path__ + "static/media/close-black.f74a3be2.svg";